import React from "react";
import Components from "../../components";

const Notifications = ({ data, dataSetter }) => {
  return (
    <div>
      <Components.PageHeader
        id="page-header"
        label="Page Header"
        title="Bildirimler"
        safeArea={data?.system?.safeArea}
        pixelRatio={data?.system?.pixelRatio}
      />
      <Components.Notifications
        id="notifications"
        label="Notifications"
        data={data}
        dataSetter={dataSetter}
      />
    </div>
  );
};

export default Notifications;
